var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 400C146.566 400 96.3636 379.192 58.5859 341.414C20.8081 303.636 0 253.434 0 200C0 146.566 20.8081 96.3636 58.5859 58.5859C96.3636 20.8081 146.566 0 200 0C253.434 0 303.636 20.8081 341.414 58.5859C379.192 96.3636 400 146.566 400 200C400 253.434 379.192 303.636 341.414 341.414C303.636 379.192 253.434 400 200 400ZM200 16.2626C98.6869 16.2626 16.2626 98.6869 16.2626 200C16.2626 301.313 98.6869 383.737 200 383.737C301.313 383.737 383.737 301.313 383.737 200C383.737 98.6869 301.313 16.2626 200 16.2626ZM176.162 141.414L59.3939 112.525L136.97 204.545L73.3333 306.768L184.848 261.414L262.424 353.434L253.737 233.434L365.253 188.081L248.485 159.192L239.798 39.1919L176.162 141.414Z",
    fill: "url(#paint0_linear_253_2714)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_253_2714",
    x1: 29.7797,
    y1: 157.938,
    x2: 418.254,
    y2: 253.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF5A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6354,
    stopColor: "#93D4CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#719AD1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.d42fc064510ff271e9f7fa74a85b0365.svg";
export { ForwardRef as ReactComponent };